var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWearTear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "56px",
    viewBox: "0 0 52 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-describedby": "wear-tear-title wear-tear-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "wear-tear-title"
  }, "Wear and Tear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "wear-tear-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "wear-tear-desc"
  }, "A shield")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLY_IconFamily_v2-copy",
    transform: "translate(-96.000000, -191.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(97.988000, 192.220100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.275,5.949 L24.213,-3.55271368e-15 L0,8.97 L0.455,25.053 C0.455,25.053 0.336,36.251 8.532,44.448 C13.076,48.991 19.807,53.13 24.213,53.13 C28.618,53.13 35.349,48.991 39.892,44.448 C48.088,36.251 47.97,25.053 47.97,25.053 L48.425,8.97 L44.966,7.688",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001,17.0008 L37.0001,17.0008",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001,23.0008 L37.0001,23.0008",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001,29.0008 L37.0001,29.0008",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001,35.0008 L37.0001,35.0008",
    id: "Stroke-9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWearTear);
export default __webpack_public_path__ + "static/media/wear-tear.e3a97ff20f249b09e021501504cb522f.svg";
export { ForwardRef as ReactComponent };